import React from 'react'
import { css } from '@emotion/react'
import { string } from 'prop-types'

import { getDesignationLabel } from '@/utils/products'
import NotInstallableButton from './NotInstallableButton'
import RequestProductAccess from './RequestProductAccess'

const infoCss = css`
  margin-top: 0;
`

const NotAssignedToProduct = ({ designation, appId, ...props }) => {
  const designationLabel = getDesignationLabel(designation)

  return (
    <NotInstallableButton {...props} appId={appId}>
      <div>
        <p css={infoCss}>
          Request access to {designationLabel} from your organization Owner.
        </p>

        <RequestProductAccess designation={designation} />
      </div>
    </NotInstallableButton>
  )
}

NotAssignedToProduct.propTypes = {
  designation: string,
  appId: string,
}

export default NotAssignedToProduct
